import { useRef, useState } from 'react';
import clsx from 'clsx';
import { useAmplitude } from 'hooks/useAmplitude';
import { AMPLITUDE_EVENTS } from 'utils/tracking/tracking.events';
import { NotificationButton } from '../NotificationButton/NotificationButton';
import { useNotifications } from '../useNotifications/useNotifications';
import { NotificationsContainer } from './NotificationsContainer/NotificationsContainer';
import styles from './NotificationsWidget.module.css';

export const NotificationsWidget = ({
  introducerId,
}: {
  introducerId: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const { trackEvent } = useAmplitude();
  const containerRef = useRef<HTMLDivElement>(null);
  const notificationsData = useNotifications(containerRef, introducerId);
  const { numberUnread } = notificationsData;

  const handleToggle = () => {
    setIsOpen(!isOpen);
    trackEvent(AMPLITUDE_EVENTS.notificationsBellClicked, {
      'Number unread': numberUnread,
    });
  };

  return (
    <div className={styles.notificationsButtonWrapper}>
      <NotificationButton
        onClick={handleToggle}
        isOpen={isOpen}
        numberUnread={numberUnread}
      />

      <div
        className={clsx(styles.notificationWrapper, {
          [styles.isOpen]: isOpen,
        })}
        data-testid="notification-wrapper"
      >
        <NotificationsContainer
          notificationsData={notificationsData}
          containerRef={containerRef}
          onCloseContainer={handleToggle}
        />
        <div
          data-testid="notification-backdrop"
          onClick={handleToggle}
          className={styles.backdrop}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => (e.key === 'Enter' ? handleToggle() : undefined)}
        />
      </div>
    </div>
  );
};
